var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExplore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 501.842,
    height: 284.722,
    viewBox: "0 0 501.842 284.722",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#496dfa;}.b{fill:#6a95f9;}.c{fill:#fff;}.d,.e{fill:#dee6fc;}.e{font-size:13px;font-family:Helvetica;}.f{fill:#e488c7;}.g{fill:#716ef1;}.h{fill:#514db5;}.i{fill:#88d4ef;}.j{fill:#f0ca76;}.k{fill:#e6ca76;}.l,.n{fill:none;stroke:#88d4ef;stroke-width:4px;}.l{stroke-miterlimit:10;}.m{fill:#524cb3;}.n{stroke-linecap:round;stroke-linejoin:round;}.o{fill:#70c4ea;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-36.094 -88.74)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.094 88.74)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(85.21 43.698)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 51.94,
    height: 68.73,
    transform: "translate(139.847 172.157)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M331.595,332.507H190.458a4,4,0,0,1-4-4h0a3.766,3.766,0,0,1,3.766-3.766h141.6a3.766,3.766,0,0,1,3.766,3.766h0A4,4,0,0,1,331.595,332.507Z",
    transform: "translate(-95.21 -91.484)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 331.633,
    height: 206.522,
    rx: 5.349,
    transform: "translate(331.633 206.522) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 306.199,
    height: 172.735,
    transform: "translate(12.717 12.716)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 80.028,
    height: 31.937,
    transform: "translate(29.784 132.442)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 80.028,
    height: 31.937,
    transform: "translate(125.755 132.442)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 80.028,
    height: 31.937,
    transform: "translate(221.725 132.442)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(114.994 70.629)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 68.472,
    height: 6.438
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 18.142,
    height: 4.161,
    transform: "translate(117.241 2.504)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 26.335,
    height: 4.161,
    transform: "translate(158.207 2.504)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 26.335,
    height: 4.161,
    transform: "translate(203.465 2.504)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 26.335,
    height: 4.161,
    transform: "translate(248.722 2.504)"
  })), /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(114.994 125.311)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Expent is at work")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(114.994 135.13)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 17.977,
    height: 3.513
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 7.197)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 105.183,
    height: 4.131
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 7.132)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 105.183,
    height: 4.131
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 14.264)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 56.307,
    height: 4.131
  })))), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M199.986,88.74H50.025a13.93,13.93,0,1,0,0,27.861H187.756l8.509,10.728V116.6h3.721a13.93,13.93,0,0,0,0-27.861Z",
    transform: "translate(-36.094 -88.74)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.21 92.35)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 108.928,
    height: 108.928,
    rx: 3.95
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.367 9.119)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.405)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M89.4,265.835a45.142,45.142,0,1,1,45.144-45.142A45.193,45.193,0,0,1,89.4,265.835Zm0-84.915a39.772,39.772,0,1,0,39.772,39.772A39.818,39.818,0,0,0,89.4,180.92Z",
    transform: "translate(-44.255 -175.55)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.399 9.399)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M88.007,255.046A35.743,35.743,0,1,1,123.752,219.3,35.783,35.783,0,0,1,88.007,255.046Zm0-66.117A30.373,30.373,0,1,0,118.381,219.3,30.408,30.408,0,0,0,88.007,188.929Z",
    transform: "translate(-52.264 -183.559)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.457 9.399)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M83.119,255.046a2.685,2.685,0,1,1,0-5.37,30.373,30.373,0,0,0,0-60.747,2.685,2.685,0,1,1,0-5.37,35.743,35.743,0,1,1,0,71.487Z",
    transform: "translate(-80.434 -183.559)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.798 18.798)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M86.618,244.257a26.345,26.345,0,1,1,26.346-26.345A26.374,26.374,0,0,1,86.618,244.257Zm0-47.319a20.974,20.974,0,1,0,20.975,20.975A21,21,0,0,0,86.618,196.938Z",
    transform: "translate(-60.273 -191.568)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.196 28.196)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M85.228,233.47a16.946,16.946,0,1,1,16.946-16.947A16.965,16.965,0,0,1,85.228,233.47Zm0-28.523a11.577,11.577,0,0,0-11.576,11.576,11.576,11.576,0,1,0,11.576-11.576Z",
    transform: "translate(-68.282 -199.577)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.196 28.196)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M85.228,233.47a16.965,16.965,0,0,1-16.946-16.947,2.685,2.685,0,0,1,5.37,0,11.576,11.576,0,1,0,11.576-11.576,2.685,2.685,0,0,1,0-5.37,16.946,16.946,0,0,1,0,33.893Z",
    transform: "translate(-68.282 -199.577)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.052)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M125.636,223.842a3.09,3.09,0,0,1-3.09-3.09,39.412,39.412,0,0,0-39.367-39.367,3.09,3.09,0,1,1,0-6.18,45.6,45.6,0,0,1,45.547,45.547A3.09,3.09,0,0,1,125.636,223.842Z",
    transform: "translate(-80.089 -175.205)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.38 18.798)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M85.792,244.722a26.787,26.787,0,0,1-19.981-8.979,3.09,3.09,0,0,1,4.616-4.111A20.565,20.565,0,1,0,85.792,197.4a3.09,3.09,0,1,1,0-6.18,26.75,26.75,0,1,1,0,53.5Z",
    transform: "translate(-65.03 -191.223)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M127.136,184.013l9.693-7.688h-9.693",
    transform: "translate(-20.505 -165.891)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(431.163 158.657)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 70.678,
    height: 70.678,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.342 14.175)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 6.145,
    height: 11.499,
    transform: "translate(0 27.949)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 6.145,
    height: 26.291,
    transform: "translate(8.711 13.156)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 6.145,
    height: 17.261,
    transform: "translate(17.421 22.186)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 6.145,
    height: 34.522,
    transform: "translate(26.132 4.925)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 6.145,
    height: 39.447,
    transform: "translate(34.843)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 6.145,
    height: 1.315,
    transform: "translate(0 43.152)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 6.145,
    height: 1.315,
    transform: "translate(8.711 43.152)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 6.145,
    height: 1.315,
    transform: "translate(17.421 43.152)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 6.145,
    height: 1.315,
    transform: "translate(26.132 43.152)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 6.145,
    height: 1.315,
    transform: "translate(34.843 43.152)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M84.33,141.8a5.438,5.438,0,1,1-5.438-5.437A5.438,5.438,0,0,1,84.33,141.8Z",
    transform: "translate(-29.611 -80.475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M416.2,309.883a5.438,5.438,0,1,1-5.438-5.438A5.439,5.439,0,0,1,416.2,309.883Z",
    transform: "translate(27.98 -51.308)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 4.581,
    cy: 4.581,
    r: 4.581,
    transform: "translate(62.087 68.422)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.682 212.28)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 98.458,
    height: 66.308,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 56.262,
    height: 88.411,
    transform: "translate(93.434 5.023) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1134.318 -1132.801)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1100.5 1151)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M65.386,17.941c.026-.367.055-.731.055-1.1A14.339,14.339,0,0,0,51.1,2.5c-.371,0-.735.029-1.1.055V17.941Z",
    transform: "translate(-34.559 -2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M15.734,24.846V9.46A14.326,14.326,0,0,0,2.5,23.741c0,.374.029.738.055,1.105A14.323,14.323,0,0,0,15.734,38.025c.367.026.731.055,1.105.055A14.326,14.326,0,0,0,31.12,24.846Z",
    transform: "translate(-2.5 -7.197)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(281.72 21.55)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "n",
    y2: 9.296,
    transform: "translate(4.648)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "n",
    x1: 9.296,
    transform: "translate(0 4.648)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(479.772 127.324)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "n",
    y2: 9.296,
    transform: "translate(4.648)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "n",
    x1: 9.296,
    transform: "translate(0 4.648)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(150.36 258.529)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "n",
    y2: 9.296,
    transform: "translate(4.648)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "n",
    x1: 9.296,
    transform: "translate(0 4.648)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M187.222,308.578A2.579,2.579,0,1,1,184.643,306,2.579,2.579,0,0,1,187.222,308.578Z",
    transform: "translate(-10.763 -51.038)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M195.487,311.923a1.529,1.529,0,1,1-1.528-1.528A1.528,1.528,0,0,1,195.487,311.923Z",
    transform: "translate(-8.964 -50.275)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 4.107,
    cy: 4.107,
    r: 4.107,
    transform: "translate(15.537 220.986)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 4.732,
    cy: 4.732,
    r: 4.732,
    transform: "translate(416.842 260.694)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(267.064 11.616)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 3.221,
    cy: 3.221,
    r: 3.221
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M295.477,116.4a2.738,2.738,0,1,1-2.739-2.738A2.738,2.738,0,0,1,295.477,116.4Z",
    transform: "translate(-259.097 -96.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M298.569,109.055a1.951,1.951,0,1,1-1.952-1.952A1.952,1.952,0,0,1,298.569,109.055Z",
    transform: "translate(-258.287 -97.169)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(230.257 27.044)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M233.806,111.785H252.9a1.5,1.5,0,0,1,1.5,1.5v16.867a1.5,1.5,0,0,1-1.5,1.5h-5.682l-3.863,3.862-3.862-3.862h-5.682a1.5,1.5,0,0,1-1.5-1.5V113.289A1.5,1.5,0,0,1,233.806,111.785Z",
    transform: "translate(-232.302 -111.785)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(362.389 239.254)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 15.869,
    cy: 15.869,
    r: 15.869,
    transform: "translate(0 31.296) rotate(-80.43)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1487.051 -1154.328)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1479.44 1162)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M15.944,6.07c-5.726,0-10.384,4.32-10.384,9.645a9.217,9.217,0,0,0,2.883,6.676l-.562,3.366a.593.593,0,0,0,.872.609L11.867,24.6a11,11,0,0,0,4.076.785c5.726,0,10.384-4.32,10.384-9.653S21.669,6.07,15.944,6.07Zm5.965,9.4L21.442,19A1.771,1.771,0,0,1,19.69,20.53H16.556a5.691,5.691,0,0,1-1.983-.353l-1.064-.389a.554.554,0,0,1-.393.145H10.548a.589.589,0,0,1-.589-.589V14.117a.589.589,0,0,1,.589-.589h2.58a.577.577,0,0,1,.393.145,2.859,2.859,0,0,0,1.363-.856,3.605,3.605,0,0,0,.192-1.7c0-.216-.02-.432-.02-.656a.974.974,0,0,1,.573-.88,2.019,2.019,0,0,1,2.03.393,3.166,3.166,0,0,1,.982,3.055h1.127a2.168,2.168,0,0,1,2.14,2.443Zm-10.772-.785h1.4v4.045h-1.4Zm9.37-.173a.97.97,0,0,1,.232.785l-.483,3.534a.589.589,0,0,1-.585.507H16.556a4.552,4.552,0,0,1-1.571-.279l-1.268-.448V14.855a3.908,3.908,0,0,0,2.227-1.539,4.611,4.611,0,0,0,.3-2.25q0-.224,0-.448a1.049,1.049,0,0,1,.672.247c.342.271.856.97.459,2.6a.585.585,0,0,0,.569.727h1.838a.97.97,0,0,1,.723.338Z",
    transform: "translate(-5.56 -6.07)"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 176.139,
    height: 109.186,
    rx: 3.95,
    transform: "translate(325.702 0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(339.999 11.261)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M334.456,98.573l-8.421,8.718a.779.779,0,0,0-.218.54v7.718a.778.778,0,0,0,.778.778h5.7a.778.778,0,0,0,.778-.778v-3.756a1.942,1.942,0,0,1,1.942-1.943h0a1.943,1.943,0,0,1,1.943,1.943v3.756a.778.778,0,0,0,.778.778h5.7a.778.778,0,0,0,.778-.778v-7.718a.779.779,0,0,0-.218-.54l-8.421-8.718A.779.779,0,0,0,334.456,98.573Z",
    transform: "translate(-325.816 -98.336)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.21 218.956)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 32.734,
    height: 32.734,
    rx: 3.804
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M62.505,299.242l-4.432-4.434a9.354,9.354,0,1,0-2.31,2.309l4.432,4.434Zm-12.076-3.7a6.064,6.064,0,1,1,6.064-6.064A6.071,6.071,0,0,1,50.43,295.538Z",
    transform: "translate(-35.436 -274.481)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 106.454,
    height: 107.999,
    rx: 3.95,
    transform: "translate(360.545 43.867)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(374.566 56.438)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 8.877,
    height: 2.663
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.611)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 35.73,
    height: 2.663
  })), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 5.844,
    height: 2.663,
    transform: "translate(13.611 4.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 33.177,
    height: 2.663,
    transform: "translate(45.235 9.321)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 18.457,
    height: 2.663,
    transform: "translate(20.824 4.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 5.844,
    height: 2.663,
    transform: "translate(13.611 18.642)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 6.621,
    height: 2.663,
    transform: "translate(20.824 18.642)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 30.255,
    height: 2.663,
    transform: "translate(13.611 9.321)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 64.801,
    height: 2.663,
    transform: "translate(13.611 13.981)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 30.776)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 8.877,
    height: 2.663
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.611)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 35.73,
    height: 2.663
  })), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 5.844,
    height: 2.663,
    transform: "translate(13.611 4.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 33.177,
    height: 2.663,
    transform: "translate(45.235 9.321)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 18.457,
    height: 2.663,
    transform: "translate(20.824 4.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 5.844,
    height: 2.663,
    transform: "translate(13.611 18.642)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 6.621,
    height: 2.663,
    transform: "translate(20.824 18.642)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 30.255,
    height: 2.663,
    transform: "translate(13.611 9.321)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 64.801,
    height: 2.663,
    transform: "translate(13.611 13.981)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 61.553)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 8.877,
    height: 2.663
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.611)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 35.73,
    height: 2.663
  })), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 5.844,
    height: 2.663,
    transform: "translate(13.611 4.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 33.177,
    height: 2.663,
    transform: "translate(45.235 9.321)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 18.457,
    height: 2.663,
    transform: "translate(20.824 4.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 5.844,
    height: 2.663,
    transform: "translate(13.611 18.641)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 6.621,
    height: 2.663,
    transform: "translate(20.824 18.641)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 30.255,
    height: 2.663,
    transform: "translate(13.611 9.321)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 64.801,
    height: 2.663,
    transform: "translate(13.611 13.981)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore);
export default __webpack_public_path__ + "static/media/explore.58d40aa6f253b4913179c3ef6ef73b5d.svg";
export { ForwardRef as ReactComponent };